<div class="thread-header">
  <button type="button" class="back-btn" (click)="onBack()" attr.aria-label="{{'admin_support.lbl_back' | translate}}">←</button>
  <div class="thread-title-block">
    <div class="thread-title">{{thread()?.topic}}</div>
  </div>
  <button type="button" class="btn-close-case btn ft-btn-primary ft-btn-primary--outline ft-btn-primary--small" *ngIf="thread()?.status === 'Open'" [disabled]="closing()" (click)="onCloseCase()">
    <i class="fa fa-spinner fa-spin" *ngIf="closing()"></i>
    {{ (closing() ? 'admin_support.lbl_closing' : 'admin_support.lbl_close_case') | translate }}
  </button>
</div>

<div class="thread-messages">
  @let failLabel = 'admin_support.lbl_email_delivery_failed_indicator' | translate;
  <div class="msg" *ngFor="let m of thread()?.messages" [ngClass]="authorClass(m.authorType)">
    <div class="bubble"><app-email-message [message]="m.message"></app-email-message></div>
    <div class="meta">
      {{authorLabel(m)}} · {{m.createdOn | osloDate}}
      <i class="fa fa-exclamation-triangle email-delivery-failed" *ngIf="m.emailDeliveryFailed"
         role="img"
         [attr.title]="failLabel"
         [attr.aria-label]="failLabel"></i>
    </div>
  </div>
</div>

<div class="reply-box" *ngIf="thread()?.status === 'Open'; else closedNotice">
  <div class="textarea-wrapper">
    <textarea #replyTextarea class="form-control" [ngModel]="replyText()" (ngModelChange)="replyText.set($event)"
      (keydown)="onReplyKeydown($event)" [attr.disabled]="sending() ? true : null"
      placeholder="{{'admin_support.lbl_reply_placeholder' | translate}}"></textarea>
    <button type="button" class="btn-expand-composer" (click)="onExpandComposer()"
      attr.aria-label="{{'admin_support.lbl_expand_composer' | translate}}" [attr.title]="'admin_support.lbl_expand_composer' | translate">
      <i class="fa fa-expand"></i>
    </button>
  </div>
  <div class="reply-actions">
    <span class="send-hint">{{'admin_support.lbl_send_hint' | translate}}</span>
    <span class="char-count-block"><span class="char-count">{{replyCharCount()}}</span> {{'admin_support.lbl_characters' | translate}}</span>
    <button type="button" class="btn-send-reply btn ft-btn-primary" [disabled]="sending()" (click)="onSendReply()">
      <i class="fa fa-spinner fa-spin" *ngIf="sending()"></i>
      {{ (sending() ? 'admin_support.lbl_sending' : 'admin_support.lbl_send_reply') | translate }}
    </button>
  </div>
</div>
<ng-template #closedNotice>
  <div class="reply-box">
    <textarea class="form-control" disabled placeholder="{{'admin_support.lbl_reply_disabled_placeholder' | translate}}"></textarea>
  </div>
  <div class="closed-notice">{{'admin_support.lbl_closed_notice' | translate}}</div>
</ng-template>

<div class="composer-backdrop" *ngIf="composerOpen()" (click)="onCloseComposer()">
  <div class="composer-modal" (click)="$event.stopPropagation()">
    <div class="composer-header">
      <span class="composer-title">{{'admin_support.lbl_composer_title' | translate}}</span>
      <button type="button" class="btn-close-composer" (click)="onCloseComposer()"
        attr.aria-label="{{'admin_support.lbl_collapse_composer' | translate}}">&times;</button>
    </div>
    <div class="composer-body">
      <div class="composer-latest-message" *ngIf="latestCustomerMessage() as latest">
        <div class="composer-latest-label">{{'admin_support.lbl_composer_latest_message' | translate}}</div>
        <div class="bubble"><app-email-message [message]="latest.message"></app-email-message></div>
      </div>
      <textarea class="form-control" [ngModel]="replyText()" (ngModelChange)="replyText.set($event)"
        (keydown)="onReplyKeydown($event)" [attr.disabled]="sending() ? true : null"
        placeholder="{{'admin_support.lbl_reply_placeholder' | translate}}"></textarea>
    </div>
    <div class="reply-actions">
      <span class="send-hint">{{'admin_support.lbl_send_hint' | translate}}</span>
      <span class="char-count-block"><span class="char-count">{{replyCharCount()}}</span> {{'admin_support.lbl_characters' | translate}}</span>
      <button type="button" class="btn-send-reply btn ft-btn-primary" [disabled]="sending()" (click)="onSendReply()">
        <i class="fa fa-spinner fa-spin" *ngIf="sending()"></i>
        {{ (sending() ? 'admin_support.lbl_sending' : 'admin_support.lbl_send_reply') | translate }}
      </button>
    </div>
  </div>
</div>
